export enum DocumentationTypeEnum {
  Document,
  Url,
  HtmlContent
}

export interface DocumentModel {
  documentationId: number;
  nom: string;
  description: string;
  fileName: string;
  createdAt: Date;
  createdAtString: string;

  isDownloading: boolean;
  type: DocumentationTypeEnum;
}

export interface DocumentTreeNodeModel {
  name: string;
  description?: string;
  isFolder: boolean;
  document?: DocumentModel;
  isOpen?: boolean;
  children?: DocumentTreeNodeModel[];
}
